import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import { Search } from "lucide-react";

// Ex : campagne de vaccination, enquête, ...
interface SearchInputProps {
  placeholder?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: boolean;
  styles?: React.CSSProperties;
  onSubmit: () => void;
}

export function UiSearchInput({
  placeholder,
  onSubmit,
  leftIcon,
  rightIcon = true,
  styles = {},
}: SearchInputProps) {
  return (
    <Paper
      component="form"
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 400,
        border: "2px solid #EEEEEE",
        boxShadow: "none",
        ...styles,
      }}
      onSubmit={onSubmit}
    >
      {leftIcon && (
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          {leftIcon}
        </IconButton>
      )}
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ "aria-label": `${placeholder}` }}
      />
      {rightIcon && (
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <img
            src="/assets/icons/search-icon-alt.svg"
            alt="search"
            width={20}
            height={20}
          />
        </IconButton>
      )}
    </Paper>
  );
}

export function UiDashboardSearchInput({
  placeholder,
  onSubmit,
}: SearchInputProps) {
  return (
    <Paper
      component="form"
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 400,
        border: "1px solid #EBEBEB",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "none",
      }}
      onSubmit={onSubmit}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ "aria-label": `${placeholder}` }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <img
          src="/assets/icons/dashboard-search-icon.svg"
          alt="search"
          width={20}
          height={20}
        />
      </IconButton>
    </Paper>
  );
}

export function UiCardSearchInput({
  placeholder,
  onSubmit,
  rightIcon = false,
  styles = {},
}: SearchInputProps) {
  return (
    <>
      <UiSearchInput
        leftIcon={<Search size={16} />}
        styles={{ borderRadius: "10px", width: "230px", ...styles }}
        onSubmit={onSubmit}
        rightIcon={rightIcon}
        placeholder={placeholder}
      />
    </>
  );
}
